import { Component, HostListener, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router, ActivatedRoute } from '@angular/router';


import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-esign',
  templateUrl: './esign.component.html',
})
export class EsignComponent {



  loading: boolean = false;

  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {


    this.fetchTerms();



  }
  content;


  fetchTerms() {

    this.loading = true;

    const request = {
      Type: 'esign'
    }



    this.httpService.post<any>('Store/fetch-settings', request, false).subscribe(
      resp => {
        this.content = JSON.parse(resp.message);

        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }



}
